var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_36724",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V33H32V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_36724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.49 15.2184L19.9299 3.30042C19.5999 2.96042 19.1599 2.77344 18.6899 2.77344C18.2199 2.77344 17.79 2.96042 17.46 3.30042L16.4099 4.38342C16.0799 4.72242 15.8899 5.17643 15.8899 5.66043C15.8899 6.14343 16.0799 6.61242 16.4099 6.95242L23.1499 13.9204H1.72998C0.75998 13.9204 0 14.6994 0 15.6954V17.2254C0 18.2224 0.75998 19.0804 1.72998 19.0804H23.22L16.4099 26.0874C16.0799 26.4274 15.8999 26.8684 15.8999 27.3524C15.8999 27.8354 16.0799 28.2834 16.4099 28.6234L17.46 29.7014C17.79 30.0424 18.2199 30.2274 18.6899 30.2274C19.1599 30.2274 19.5999 30.0394 19.9299 29.6994L31.49 17.7824C31.82 17.4404 32 16.9854 32 16.5014C32 16.0154 31.82 15.5594 31.49 15.2184Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/Right-arrow.557af85f941e531936233dc422350a70.svg";
export { ForwardRef as ReactComponent };